var offCanvas = null;

$(document).ready(function () {
    try {
        if (document.getElementById('offcanvasChecklist')) {
            offCanvas = new bootstrap.Offcanvas('#offcanvasChecklist');
        }
    } catch (e) {
        console.log('[DEBUG] Init OffCanvas', e);
    }

    $('#nav-tabs table tbody tr').each(function () {
        // Controlla se uno degli span all'interno del tr ha la classe Items_ListItemSelected
        if ($(this).find('span.Items_ListItemSelected').length > 0) {
            // Aggiungi la classe 'selected' al tr
            $(this).addClass('tab-selected');
        }
    });

    $('#toggleSidebar').on('click', function () {
        const $sidebar = $('#sidebar');
        const $content = $('#content');

        if ($sidebar.hasClass('expanded')) {
            $sidebar.removeClass('expanded').addClass('collapsed');
            $content.removeClass('expanded').addClass('collapsed');
            if ($('#sidebar-btn')) {
                $('#sidebar-btn').removeClass('d-block').addClass('d-none');
            }
        } else {
            $sidebar.removeClass('collapsed').addClass('expanded');
            $content.removeClass('collapsed').addClass('expanded');
            if ($('#sidebar-btn')) {
                $('#sidebar-btn').removeClass('d-none').addClass('d-block');
            }
        }
    });

    $('#settings-toggled').click((e) => {
        if ($('#settingsMenu').hasClass('show')) {
            $('#settings-toggled').removeClass('show');
            $('#settingsMenu').removeClass('show');
        } else {
            $('#settings-toggled').addClass('show');
            $('#settingsMenu').addClass('show');
        }
    });

    $('#sticky-header-chevron').click((e) => {
        e.preventDefault();
        handleClickStickyHeader();
    });

    $('#closeSystemMessageModal').click((e) => {
        e.preventDefault();
        application.ModalManagerIstance.show(application.SystemGenericModalIstance.Id);
    });
    //initializeStickyHeader();
    setActiveMenuItem();
    toggleSubmenu();
    tableScroll();
});

HTMLTableRowElement.prototype.insert_th_Cell = function (index) {
    let cell = this.insertCell(index)
        , c_th = document.createElement('th')
    cell.replaceWith(c_th)
    return c_th
}
function addDataTables(target) {
    try {
        var table = document.getElementById(target);

        if (!table) {
            throw ('La tabella non è stata trovata.');
        }

        var rows = table.getElementsByTagName('tr');

        if (rows.length < 3) {
            throw ('La tabella non contiene abbastanza righe.');
        }

        var thead = table.querySelector('thead');
        if (!thead) {
            thead = table.createTHead();
        }

        var tbody = table.querySelector('tbody');

        var thirdRow = rows[2];

        var cells = thirdRow.getElementsByTagName('td');

        const newRow = thead.insertRow();

        for (var i = 0; i < cells.length; i++) {
            var cell = cells[i];
            newRow.insert_th_Cell().textContent = cell.textContent;
        }

        for (var j = 0; j < 3; j++) {
            if (tbody.rows.length > 0) {
                tbody.deleteRow(0);
            }
        }
        $.fn.dataTable.Buttons.defaults.dom.button.className = 'btn';
        $(table).DataTable({
            'layout': {
                'topStart': {
                    'buttons': [
                        {
                            className: 'btn-primary',
                            extend: 'excel'
                        },
                        {
                            className: 'btn-primary',
                            extend: 'pdf'
                        },
                        {
                            className: 'btn-primary',
                            extend: 'print'
                        }
                    ]
                }
            },
            'autoWidth': false,
            'paging': false,
            'fixedHeader': false,
            'language': {
                'url': '/Scripts/datatables/it-IT.json',
            }
        });

        resizeColumns();
    } catch (error) {
        console.log('[DEBUG] ', 'Error function addDataTables(target)', error);
    }
}

function resizeColumns() {
    try {
        $('table th').resizable({
            handles: 'e',
            stop: function (e, ui) {
                $(this).width(ui.size.width);
            }
        });
    } catch (error) {
        console.log('[DEBUG] ', 'Error function resizeColumns()', error);

    }

}
function openModalMenuDx() {
    $('#modal-menu-dx').modal('show');
}
function closeModalMenuDx() {
    $('#modal-menu-dx').modal('hide');
}

function toggleSubmenu() {
    try {
        const $links = $('.nav-link[data-target]');
        let $activeSubmenu = null;
        let $activeLink = null;

        $links.on('click', function (e) {
            e.preventDefault();
            const targetId = $(this).data('target');
            const $targetSubmenu = $('#' + targetId);

            if ($activeSubmenu && $activeSubmenu[0] !== $targetSubmenu[0]) {
                $activeSubmenu.removeClass('show');
                if ($activeLink) {
                    $activeLink.removeClass('active');
                }
            }

            if ($targetSubmenu.hasClass('show')) {
                $targetSubmenu.removeClass('show');
                $(this).removeClass('active');
                $activeSubmenu = null;
                $activeLink = null;
            } else {
                $targetSubmenu.addClass('show');
                $(this).addClass('active');
                $activeSubmenu = $targetSubmenu;
                $activeLink = $(this);
            }
        });

    } catch (error) {
        console.log('[DEBUG] ', 'Error function toggleSubmenu()', error);

    }
}

function collapseBodyCard(target = true) {
    if (target) {
        $('.card-body').removeClass('show');
        //    $('.card-footer').addClass('show');
    } else {
        $('.card-body').addClass('show');
        //$('.card-footer').removeClass('show');
        //[
        //    'pnlBlacklist',
        //    'pnlMarkNNDescription',
        //    'pnlImportExport',
        //    'pnlCustomerTypeDescription',
        //    'pnlRevisionDocuments',
        //    'pnlOffices',
        //    'pnlStock',
        //    'pnlStatus',
        //    'pnlInfo',
        //    'pnlLastForfait',
        //    'pnlUpdate',
        //    'pnlExport'
        //].map((item) => {
        //    CollapsePanel(item);
        //});
    }
}

function setActiveMenuItem() {
    try {
        var currentPath = window.location.pathname + window.location.search;
        $('#desktopNavbar .collapse.navbar-collapse ul li a').each(function () {
            var menuUrl = $(this).attr('href');

            if (menuUrl !== "#" && currentPath.includes(menuUrl.split('?')[0])) {
                $(this).addClass('active');
                return false;
            }

            if (menuUrl === "#") {
                let targetId = $(this).data('target');
                let targetElement = $('#' + targetId);

                if (targetElement.length) {
                    targetElement.find('a').each(function () {
                        let innerHref = $(this).attr('href');
                        if (currentPath.includes(innerHref.split('?')[0])) {
                            $('#desktopNavbar .collapse.navbar-collapse ul li a').filter(function () {
                                return $(this).data('target') === targetId;
                            }).addClass('active');
                            return false;
                        }
                    });
                }
            }
        });
    } catch (error) {
        console.log('[DEBUG] ', 'Error function setActiveMenuItem()', error);

    }
}

function handleClickStickyHeader() {
    try {
        if ($('.card-body').hasClass('show')) {
            $('.card-body').removeClass('show');
            $('#sticky-header').addClass('active');
            $('#sticky-header-chevron').removeClass('rotated');
        } else {
            $('#sticky-header-chevron').addClass('rotated');
            $('#sticky-header').removeClass('active');
            $('.card-body').addClass('show');
            $('.bs-main-container').animate({ scrollTop: 0 }, 500);
        }
    } catch (e) {
        console.log('[DEBUG]', 'Error handleClickStickyHeader()', e);
    }
}

// Funzione di debounce per ridurre le chiamate
function debounce(func, delay) {
    let debounceTimer;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
}

let lastGlobalSearchAjaxRequest;
function handleTypingSearchModal(element, searchTriggerElement) {
    if (element != null && element.value.length >= 3) {
        if (lastGlobalSearchAjaxRequest) {
            // Annulla la richiesta AJAX in corso
            lastGlobalSearchAjaxRequest.abort();
            //console.log("Richiesta annullata dal client");
        }
        debounce(handleSearchModal(searchTriggerElement), 300);
    } else {

        document.getElementById('global-search-warning').classList.remove('d-none');

        document.getElementById('clienti-result-container').classList.add('d-none');
        document.getElementById('commesse-result-container').classList.add('d-none');
        document.getElementById('offerte-result-container').classList.add('d-none');
        document.getElementById('contatti-result-container').classList.add('d-none');
        document.getElementById('utenti-result-container').classList.add('d-none');
        document.getElementById('fatture-result-container').classList.add('d-none');
        document.getElementById('res-clienti').innerHTML = '';
        document.getElementById('res-offerte').innerHTML = '';
        document.getElementById('res-commesse').innerHTML = '';
        document.getElementById('res-contatti').innerHTML = '';
        document.getElementById('res-utenti').innerHTML = '';
        document.getElementById('res-fatture').innerHTML = '';
    }
}
function handleSearchModal(element) {
    try {
        var oldElementContent = null;
        if (element != null && element.disabled != true) {
            oldElementContent = element.innerHTML;
            element.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="visually-hidden"> Loading...</span>'
            element.disabled = true;
        }

        let searchKey = $('#input-search').val();
        let commesse = $('#switch-commesse').prop('checked');
        let offerte = $('#switch-offerte').prop('checked');

        if (searchKey == '') {
            alert(
                'Il campo di ricerca non può essere vuoto. Inserisci un termine per continuare.'
            );
            return;
        } else {

            lastGlobalSearchAjaxRequest = $.ajax({
                type: 'POST',
                url: '/HttpHandlers/GlobalSearch.ashx',
                data: JSON.stringify({
                    searchKey: searchKey,
                    includeClienti: true,
                    includeCommesse: commesse,
                    includeOfferte: offerte,
                    includeContatti: true,
                    includeUtenti: true,
                    includeFatture: true,
                    pageSize: 5
                }), // Passa i parametri
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                beforeSend: function () {
                    $('#res-clienti').empty();
                    $('#res-commesse').empty();
                    $('#res-offerte').empty();
                    $('#res-contatti').empty();
                    $('#res-utenti').empty();
                    $('#res-fatture').empty();
                },
                success: function (response) {
                    //var result = JSON.parse(response);
                    if (!response.IsSuccess) {
                        alert(`Ops! qualcosa è andato storto. ${response.Message}`);
                        console.log(result);
                        return;
                    }
                    document.getElementById('global-search-warning').classList.add('d-none');

                    if (response.Data.Commesse.length == 0 &&
                        response.Data.Offerte.length == 0 &&
                        response.Data.Clienti.length == 0 &&
                        response.Data.Contatti.length == 0 &&
                        response.Data.Utenti.length == 0 &&
                        response.Data.Fatture.length == 0) {
                        document.getElementById('global-search-no-results').classList.remove('d-none');
                    } else {
                        document.getElementById('global-search-no-results').classList.add('d-none');
                    }

                    if (response.Data.Clienti.length == 0) {
                        document.getElementById('clienti-result-container').classList.add('d-none');
                        $('#res-clienti').append(
                            `<li class="list-group-item d-flex justify-content-center"><lottie-player src="/assets/lottiejson/no-result.json" background="transparent" speed="1" style="width: 110px; height: 110px;" autoplay></li>`
                        );
                    } else {
                        document.getElementById('clienti-result-container').classList.remove('d-none');
                        response.Data.Clienti.map((item) => {
                            // Crea una regex per cercare la parola, ignorando il case sensitivity
                            let regex = new RegExp("(" + searchKey + ")", "gi");
                            // Sostituisci la parola trovata con una versione evidenziata
                            let testoEvidenziato = item.Name.replace(regex, '<span class="bg-success">$1</span>');
                            $('#res-clienti').append(
                                `<li class="list-group-item  d-flex justify-content-between align-items-center">
                                    <div><i class="bi bi-buildings-fill fs-6"></i></div>
                                    <div class="px-2 flex-fill text-start">${testoEvidenziato}</div>
                                    <div  class="w-25 text-end" ><a onclick="Modal_ShowWait('','Acquisizione dati in corso ...');" href="SPCustomer.aspx?Id=${item.ID}&IdProfile=${item.IdProfile}&Ext_IdProfile=${item.ExternalIdProfile}&Ext_Id=-1&Ext_Caption=">  <i class="bi bi-arrow-right-circle"></i></a></div>   
                                 </li>`
                            );
                        });
                    }
                    //<i class="bi bi-slash-circle"></i>

                    if (response.Data.Commesse.length == 0) {
                        document.getElementById('commesse-result-container').classList.add('d-none');
                        $('#res-commesse').append(
                            `<li class="list-group-item d-flex justify-content-center"><lottie-player src="/assets/lottiejson/no-result.json" background="transparent" speed="1" style="width: 110px; height: 110px;" autoplay></li>`
                        );
                    } else {
                        document.getElementById('commesse-result-container').classList.remove('d-none');
                        response.Data.Commesse.map((item) => {
                            const tempElement = document.createElement('div');
                            tempElement.innerHTML = item.Customer_Caption;
                            var customerCaptionTest = tempElement.textContent || tempElement.innerText || "";
                            let regex = new RegExp("(" + searchKey + ")", "gi");
                            let testoEvidenziato = customerCaptionTest.replace(regex, '<span class="bg-success">$1</span>');
                            tempElement.textContent = testoEvidenziato;
                            $('#res-commesse').append(
                                `<li class="list-group-item  d-flex flex-column">
                                    <div class="d-flex justify-content-between  align-items-center">
                                        <div><i class="bi bi-archive-fill fs-6"></i></div>
                                        <div class="px-2 flex-fill text-start">
                                            <p class="w-100 text-start"><strong>${item.Name}</strong></p>
                                            <div class="w-100 text-start">${tempElement.textContent || tempElement.innerText || ""}</div>
                                          </div>
                                        <div class="w-25  text-end"><a onclick="Modal_ShowWait('','Acquisizione dati in corso ...');"  href="/SPWork.aspx?Id=${item.ID}&Ext_IdProfile=${item.ExternalIdProfile}&Ext_Id=${item.ExternalId}&Ext_Caption=a">  <i class="bi bi-arrow-right-circle"></i></a></div>
                                    </div>                                 
                                 </li>`
                            );
                        });
                    }

                    if (response.Data.Offerte.length == 0) {
                        document.getElementById('offerte-result-container').classList.add('d-none');
                        $('#res-offerte').append(
                            `<li class="list-group-item d-flex justify-content-center"><lottie-player src="/assets/lottiejson/no-result.json" background="transparent" speed="1" style="width: 110px; height: 110px;" autoplay></li>`
                        );
                    } else {
                        document.getElementById('offerte-result-container').classList.remove('d-none');
                        response.Data.Offerte.map((item) => {
                            const tempElement = document.createElement('div');
                            tempElement.innerHTML = item.Customer_Caption;
                            var customerCaptionTest = tempElement.textContent || tempElement.innerText || "";
                            let regex = new RegExp("(" + searchKey + ")", "gi");
                            let testoEvidenziato = customerCaptionTest.replace(regex, '<span class="bg-success">$1</span>');
                            tempElement.textContent = testoEvidenziato;
                            $('#res-offerte').append(
                                `<li class="list-group-item  d-flex flex-column">
                                    <div class="d-flex justify-content-between  align-items-center">
                                        <div><i class="bi bi-file-spreadsheet fs-6"></i> </div>
                                            <div class="px-2 flex-fill text-start">
                                                <p class="w-100 text-start mb-1"><strong>${item.Name}</strong></p>
                                                <div class="w-100 text-start">${tempElement.textContent || tempElement.innerText || ""}</div>
                                             </div>
                                            <div class="w-25 text-end"><a onclick="Modal_ShowWait('','Acquisizione dati in corso ...');"  href="/SPOffer.aspx?Id=${item.ID}&Ext_IdProfile=${item.ExternalIdProfile}&Ext_Id=${item.ExternalId}&Ext_Caption=a">  <i class="bi bi-arrow-right-circle"></i></a></div>
                                        </div>
                                    </li>`
                            );
                        });
                    }

                    if (response.Data.Contatti.length == 0) {
                        document.getElementById('contatti-result-container').classList.add('d-none');
                        $('#res-contatti').append(
                            `<li class="list-group-item d-flex justify-content-center"><lottie-player src="/assets/lottiejson/no-result.json" background="transparent" speed="1" style="width: 110px; height: 110px;" autoplay></li>`
                        );
                    } else {
                        document.getElementById('contatti-result-container').classList.remove('d-none');
                        response.Data.Contatti.map((item) => {
                            let regex = new RegExp("(" + searchKey + ")", "gi");
                            let testoEvidenziato = item.Name.replace(regex, '<span class="bg-success">$1</span>');
                            $('#res-contatti').append(
                                `<li class="list-group-item  d-flex justify-content-between align-items-center">
                                    <div><i class="bi bi-person-vcard-fill fs-6"></i></div>
                                    <div class="px-2 flex-fill text-start">${testoEvidenziato}</div>
                                    <div  class="w-25 text-end" ><a onclick="Modal_ShowWait('','Acquisizione dati in corso ...');" href="SPContact.aspx?Id=${item.ID}&IdProfile=${item.IdProfile}&Ext_IdProfile=${item.ExternalIdProfile}&Ext_Id=${item.ExternalId}&Ext_Caption=">  <i class="bi bi-arrow-right-circle"></i></a></div>
                                 </li>`
                            );
                        });
                    }

                    if (response.Data.Utenti.length == 0) {
                        document.getElementById('utenti-result-container').classList.add('d-none');
                        $('#res-utenti').append(
                            `<li class="list-group-item d-flex justify-content-center"><lottie-player src="/assets/lottiejson/no-result.json" background="transparent" speed="1" style="width: 110px; height: 110px;" autoplay></li>`
                        );
                    } else {
                        document.getElementById('utenti-result-container').classList.remove('d-none');
                        response.Data.Utenti.map((item) => {
                            let regex = new RegExp("(" + searchKey + ")", "gi");
                            let testoEvidenziato = item.Name.replace(regex, '<span class="bg-success">$1</span>');
                            $('#res-utenti').append(
                                `<li class="list-group-item  d-flex justify-content-between align-items-center">
                                    <div><i class="bi bi-person-fill fs-6"></i></div>
                                    <div class="px-2 flex-fill text-start">${testoEvidenziato}</div>
                                    <div  class="w-25 text-end" ><a onclick="Modal_ShowWait('','Acquisizione dati in corso ...');" href="SPUser.aspx?Id=${item.ID}&IdProfile=${item.IdProfile}&Ext_IdProfile=${item.ExternalIdProfile}&Ext_Id=${item.ExternalId}&Ext_Caption=">  <i class="bi bi-arrow-right-circle"></i></a></div>
                                 </li>`
                            );
                        });
                    }

                    if (response.Data.Fatture.length == 0) {
                        document.getElementById('fatture-result-container').classList.add('d-none');
                        $('#res-fatture').append(
                            `<li class="list-group-item d-flex justify-content-center"><lottie-player src="/assets/lottiejson/no-result.json" background="transparent" speed="1" style="width: 110px; height: 110px;" autoplay></li>`
                        );
                    } else {
                        document.getElementById('fatture-result-container').classList.remove('d-none');
                        response.Data.Fatture.map((item) => {
                            const tempElement = document.createElement('div');
                            tempElement.innerHTML = item.Customer_Caption;
                            var customerCaptionTest = tempElement.textContent || tempElement.innerText || "";
                            let regex = new RegExp("(" + searchKey + ")", "gi");
                            let testoEvidenziato = customerCaptionTest.replace(regex, '<span class="bg-success">$1</span>');
                            tempElement.textContent = testoEvidenziato;
                            let titoloEvidenziato = (item.Name || '').replace(regex, '<span class="bg-success">$1</span>');
                            $('#res-fatture').append(
                                `<li class="list-group-item  d-flex flex-column">
                                    <div class="d-flex justify-content-between  align-items-center">
                                        <div><i class="bi bi-receipt fs-6"></i></div>
                                        <div class="px-2 flex-fill text-start">
                                            <p class="w-100 text-start mb-1"><strong>${titoloEvidenziato}</strong></p>
                                            <div class="w-100 text-start">${tempElement.textContent || tempElement.innerText || ""}</div>
                                        </div>
                                        <div class="w-25 text-end"><a onclick="Modal_ShowWait('','Acquisizione dati in corso ...');" href="SPInvoice.aspx?Id=${item.ID}&Ext_IdProfile=${item.ExternalIdProfile}&Ext_Id=${item.ExternalId}&Ext_Caption=a">  <i class="bi bi-arrow-right-circle"></i></a></div>
                                    </div>
                                 </li>`
                            );
                        });
                    }
                },
                complete: function () {
                    if (element != null) {
                        element.innerHTML = oldElementContent;
                        element.disabled = false;
                    }
                    lastGlobalSearchAjaxRequest = null;
                },
                error: function (xhr, status, error) {
                    if (status != 'abort') {
                        alert(`Ops! qualcosa è andato storto. ${error}`);
                    }
                    console.log('[DEBUG] ', error);
                    console.log('[DEBUG xhr] ', xhr);
                    console.log('[DEBUG status] ', status);
                },
            });
        }

    } catch (error) {
        console.log('[DEBUG] ', error);
    }
}

let handleGlobalSearchController = new AbortController();
function handleGlobalTypingSearch(searchKey, includeClienti, includeCommesse, includeOfferte, pageSize) {
    if (handleGlobalSearchController) {
        // Annulla la richiesta AJAX in corso
        handleGlobalSearchController.abort();
        // console.log("Richiesta annullata dal client");
    }
    debounce(handleGlobalSearch(searchKey, includeClienti, includeCommesse, includeOfferte, pageSize), 300);
}

async function handleGlobalSearch(searchKey, includeClienti, includeCommesse, includeOfferte, pageSize) {
    const signal = handleGlobalSearchController.signal;
    await fetch('/HttpHandlers/GlobalSearch.ashx',
        {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
            , signal
            , body: JSON.stringify({
                searchKey: searchKey,
                includeClienti: includeClienti,
                includeCommesse: includeCommesse,
                includeOfferte: includeOfferte,
                pageSize: pageSize //-1 se vuoi farli uscire tutti
            })
        }).then((response) => {
            if (!response.ok) {
                throw new Error("Errore nella richiesta HTTP!");
            }
            return response.json(); // Gestisci la risposta, se è in formato JSON
        }).catch((error) => {
            console.error("Errore:", error);
        });
}


let handleGlobalTypingSearchController; //= new AbortController();
function handleGlobalTypingSearch(searchKey, includeClienti, includeCommesse, includeOfferte, pageSize) {
    if (handleGlobalTypingSearchController) {
        // Annulla la richiesta AJAX in corso
        handleGlobalTypingSearchController.abort();
        //console.log("Richiesta annullata dal client");
    }
    handleGlobalTypingSearchController = new AbortController();
    debounce(handleGlobalSearch(searchKey, includeClienti, includeCommesse, includeOfferte, pageSize), 300);
}

async function handleGlobalSearch(searchKey, includeClienti, includeCommesse, includeOfferte, pageSize) {
    try {
        const signal = handleGlobalTypingSearchController.signal;
        const response = await fetch('/HttpHandlers/GlobalSearch.ashx',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
                , signal
                , body: JSON.stringify({
                    searchKey: searchKey,
                    includeClienti: includeClienti,
                    includeCommesse: includeCommesse,
                    includeOfferte: includeOfferte,
                    pageSize: pageSize //-1 se vuoi farli uscire tutti
                })
            });
        if (!response.ok) {
            throw new Error("Errore nella richiesta HTTP!");
        }
        const data = await response.json();
        return data;


    } catch (e) {
        if (error.name === 'AbortError') {
            //abort comandato da debounce;
        } else {
            console.log('[DEBUG ERROR handleGlobalSearch]', e);
        }
    }
}

function handleGlobalSearchChangeSwitch(target) {
    if ($(target).attr('checked') == 'checked') {
        $(target).attr('checked', false);
    } else {
        $(target).attr('checked', true);
    }
    handleTypingSearchModal(document.getElementById('input-search'), document.getElementById('btnGlobalSearch'))
}


/* Timesheet */
function tableScroll() {
    try {
        const table1Container = document.getElementById('table1');
        const table2Container = document.getElementById('table2');
        if (table1Container != null && table2Container != null) {
            table1Container.addEventListener('scroll', function () {
                table2Container.scrollLeft = table1Container.scrollLeft;
            });

            table2Container.addEventListener('scroll', function () {
                table1Container.scrollLeft = table2Container.scrollLeft;
            });

        }
    } catch (error) {
        console.log('[DEBUG] tableScroll', error);
    }
}
function hendleDropdownRow(target) {
    try {
        const element = $(`#${target}`);

        if (element.hasClass('expanded')) {
            element.removeClass('expanded');
        } else {
            element.addClass('expanded');
        }
    } catch (error) {
        console.log('[DEBUG] hendleDropdownRow', error);
    }
}

///* OffCanvas */
//function addContentOffcanvas(title, content, width = 350) {
//    try {
//        if (offCanvas) {
//            offCanvas._element.style.width = `${width}px`;
//            $('#offcanvasChecklistTitle').empty().append(title);
//            $('#offcanvas-container').empty().append(content);
//            offCanvas.toggle();
//        } else {
//            throw new Error("offCanvas is Null");
//        }
//    } catch (error) {
//        console.log('[DEBUG] addContentOffcanvas', error);
//    }
//}

//function hideLoadingModal(Modal) {
//    const modal = bootstrap.Modal.getInstance($(Modal));
//    if (modal) {
//        modal.hide()
//    }
//}

/* Chiusura modale instant panel
   taget: id della modale
*/
function closeInstantPanelModal(target) {
    try {
        // const modal = $(`#${target}`);
        const modal = bootstrap.Modal.getInstance($(`#${target}`));

        if (modal) {
            modal.hide();
        } else {
            $(`#${target}`).modal('hide');
            // throw new Error("modal is null")
        }
    } catch (e) {
        console.lg('[DEBUG] closeInstantPanelModal: ', e);
    }
}
